import { styled } from "styled-components";
import { motion } from "framer-motion";

const Wrapper = styled.div``;

const PrimaryNavBar = ({ setCurrentPage }) => {
  return <Wrapper>Joe</Wrapper>;
};

export default PrimaryNavBar;
